<template>
  <div class="legacy-table-action-host">
    <Workspaces v-if="action === 'favorites'" :show_workspace="true" :stock="stock"
      @_closeFavoriteWorkspacesWindow="$emit('close')" />
    <WaitingValues v-else v-legacy-overlay :show_waiting="true" :stock="stock"
      @_closeWaitingValueWindow="$emit('close')" @waiting-added="$emit('waiting-added')" />
  </div>
</template>
<script>
import Workspaces from './Workspaces.vue';
import WaitingValues from './WaitingValuesAdd.vue';
import legacyOverlay from '../directives/legacyOverlay';
export default {
  name: 'LegacyTableActionDialog',
  components: { Workspaces, WaitingValues },
  directives: { legacyOverlay },
  props: { action: { type: String, required: true }, stock: { type: Object, required: true } }
};
</script>
